import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as styles from "./Tabs.module.css";
import { Tabs as RTabs, TabList as RTabList, Tab as RTab, TabPanel as RTabPanel } from "react-tabs";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
// Tabs
export const Tabs = _ref => {
  let {
    children,
    ...otherProps
  } = _ref;
  return _jsx(RTabs, {
    className: styles.tabs,
    ...otherProps,
    children: children
  });
};
Tabs.tabsRole = "Tabs";
// TabList
export const TabList = _ref2 => {
  let {
    children,
    ...otherProps
  } = _ref2;
  const [canScrollRight, setCanScrollRight] = React.useState(false);
  const [canScrollLeft, setCanScrollLeft] = React.useState(false);
  const wrapperRef = React.useRef(null);
  const handleScroll = () => {
    if (wrapperRef.current) {
      setCanScrollLeft(wrapperRef.current.scrollLeft > 0);
      setCanScrollRight(wrapperRef.current.scrollWidth - wrapperRef.current.scrollLeft > wrapperRef.current.clientWidth);
    }
  };
  const handleScrollRight = () => {
    if (wrapperRef.current) wrapperRef.current.scrollTo({
      left: wrapperRef.current.scrollWidth,
      behavior: "smooth"
    });
  };
  const handleScrollLeft = () => {
    if (wrapperRef.current) wrapperRef.current.scrollTo({
      left: 0,
      behavior: "smooth"
    });
  };
  React.useEffect(() => {
    if (wrapperRef.current) {
      setCanScrollRight(wrapperRef.current.scrollWidth > wrapperRef.current.clientWidth); // initiate scroll
    }
  }, []);
  return _jsx("div", {
    className: styles.container,
    children: _jsx("div", {
      onScroll: handleScroll,
      ref: wrapperRef,
      className: clsx(styles.wrapper),
      children: _jsxs("div", {
        className: styles.tabListContainer,
        children: [canScrollLeft && _jsx("div", {
          onClick: handleScrollLeft,
          className: clsx(canScrollLeft && styles.scrollLeftButton, styles.tabButton),
          children: _jsx("span", {
            className: styles.scrollButton,
            children: _jsx(FontAwesomeIcon, {
              icon: faChevronLeft
            })
          })
        }), _jsx(RTabList, {
          className: clsx(canScrollRight || canScrollLeft ? styles.tabListOverflow : styles.tabList),
          ...otherProps,
          children: children
        }), canScrollRight && _jsx("div", {
          onClick: handleScrollRight,
          className: clsx(canScrollRight && styles.scrollRightButton, styles.tabButton),
          children: _jsx("span", {
            className: styles.scrollButton,
            children: _jsx(FontAwesomeIcon, {
              icon: faChevronRight
            })
          })
        })]
      })
    })
  });
};
TabList.tabsRole = "TabList";
// Tab
export const Tab = _ref3 => {
  let {
    children,
    ...otherProps
  } = _ref3;
  return _jsx(RTab, {
    className: styles.tab,
    ...otherProps,
    children: children
  });
};
Tab.tabsRole = "Tab";
// TabPanel
export const TabPanel = _ref4 => {
  let {
    children,
    ...otherProps
  } = _ref4;
  return _jsx(RTabPanel, {
    ...otherProps,
    children: children
  });
};
TabPanel.tabsRole = "TabPanel";